// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CdX_","left":"styles_left__1tSbK","desktopActions":"styles_desktopActions__v26il","title":"styles_title__2OMdC"};